import {createRequest, makeRequest} from "../utils/apiUtil";

export function getById(id) {
    return makeRequest(createRequest('reservation/' + id));
}